import { Component, OnInit, inject } from '@angular/core';

import { VideoPopupComponent } from "../video-popup/video-popup.component";
import { ModalService } from '../../services/modal.service';
import { VideoPopup } from '../../services/video-popup.service';
@Component({
  selector: 'app-media-articles',
  imports: [VideoPopupComponent, VideoPopupComponent],
  templateUrl: './media-articles.component.html',
  styleUrls: ['./media-articles.component.scss']
})
export class MediaArticlesComponent implements OnInit {
  currentVideoUrl: boolean = false;
  _videoUrl = inject(VideoPopup);
  _modalService = inject(ModalService);
  handler__video(videoURL: any) {
    this._videoUrl.videoURL.set(videoURL);
    this.currentVideoUrl = true;
    setTimeout(() => {
      this._modalService.showModal('video-popup');
    }, 500);
  }
  tabs = [
    { "id": "Online", "label": "Online" },
    { "id": "Video", "label": "Video" },
    { "id": "Print", "label": "Print" },
    { "id": "Press release", "label": "Press release" }
  ];
  categoryData = [
    {
      "mediaType": "Online",
      "image_url": "/assets/images/finance-volatality.png",
      "batch": "<span>Online Coverage</span> ET Insights",
      "title": "Liquidity is the new safety net in an age of financial volatility",
      "btnText": "Read More",
      "link": "https://etedge-insights.com/markets/liquidity-is-the-new-safety-net-in-an-age-of-financial-volatility/",
      "date": "18/06/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/wealth-june-article.webp",
      "batch": "<span>Online Coverage</span> BUSINESS STANDARD",
      "title": "Retail investors not in panic mode despite geopolitical uncertainty",
      "btnText": "Read More",
      "link": "https://www.business-standard.com/amp/markets/news/retail-investors-not-in-panic-mode-despite-geopolitical-uncertainty-126060500219_1.html",
      "date": "08/06/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/puneet-asthana-media-corner.webp",
      "batch": "<span>Online Coverage</span> Express Computer",
      "title": "Why AI projects fail inside large enterprises and what leaders are learning: Puneet Asthana, ED & CTO, Shriram Group’s Capital Market Business",
      "btnText": "Read More",
      "link": "https://www.expresscomputer.in/interviews/why-ai-projects-fail-inside-large-enterprises-and-what-leaders-are-learning/135722/",
      "date": "05/06/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media-wealth.png",
      "batch": "<span>Online Coverage</span> CNBC",
      "title": "Can India’s GIFT City rival Singapore and Dubai?",
      "btnText": "Read More",
      "link": "https://www.cnbc.com/video/2026/06/01/can-indias-gift-city-rival-singapore-and-dubai.html",
      "date": "04/06/2026"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/ai-finance.webp",
      "batch": "<span>Print</span> The Free Press Journal",
      "title": "Building ResilientAPI-First Capital Markets Platforms",
      "alt_text": "Building ResilientAPI-First Capital Markets Platforms",
      "btnText": "Read More",
      "link": "/assets/pdf/World-Fintech-Souvenir-April-May-2026.pdf",
      "date": "22/05/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Puneet_Asthana.webp",
      "batch": "<span>Online Coverage</span> Economic Times CIO",
      "title": "From transactions to intelligence: How AI Is redefining FinTech and WealthTech",
      "btnText": "Read More",
      "link": "https://cio.economictimes.indiatimes.com/news/cio-dispatch/ai-revolutionizes-fintech-and-wealthtech-from-transactions-to-intelligent-insights/130059432",
      "date": "08/04/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/gift-city.png",
      "batch": "<span>Online Coverage</span> The Economic Times",
      "title": "How GIFT City can reshape cross-border investing for domestic and international investors",
      "btnText": "Read More",
      "link": "https://economictimes.indiatimes.com/markets/stocks/news/how-gift-city-can-reshape-cross-border-investing-for-domestic-and-international-investors/articleshow/129859580.cms?utm_source=whatsapp_pwa&utm_medium=social&utm_campaign=socialsharebuttons&from=mdr",
      "date": "28/03/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/oil-price.webp",
      "batch": "<span>Online Coverage</span> Business World",
      "title": "SWL Says Oil Price Surge Raising Inflation, Currency Risks For India",
      "btnText": "Read More",
      "link": "https://www.businessworld.in/article/swl-says-oil-price-surge-raising-inflation-currency-risks-for-india-597727",
      "date": "16/03/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/ai-catalyst.webp",
      "batch": "<span>Online Coverage</span> Express Computer",
      "title": "Is AI a threat or a catalyst? Rethinking the narrative for IT growth in 2026",
      "btnText": "Read More",
      "link": "https://www.expresscomputer.in/guest-blogs/is-ai-a-threat-or-a-catalyst-rethinking-the-narrative-for-it-growth-in-2026/133623/",
      "date": "16/03/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Puneet_Asthana.webp",
      "batch": "<span>Online Coverage</span> FE FUTECH",
      "title": "Agentic AI: When Software Starts Acting Like an Employee",
      "btnText": "Read More",
      "link": "https://futech.financialexpressb2b.com/blogs/agentic-ai-when-software-starts-acting-like-an-employee",
      "date": "24/02/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Vikas_Satija_03.webp",
      "batch": "<span>Online Coverage</span> The Free Press Journal",
      "title": "A Will: The Missing Pillar Of Wealth Management That Protects Your Legacy From Delay, Dispute & Disorder",
      "btnText": "Read More",
      "link": "https://www.freepressjournal.in/business/a-will-the-missing-pillar-of-wealth-management-that-protects-your-legacy-from-delay-dispute-disorder",
      "date": "20/02/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/Union_Budget.webp",
      "batch": "<span>Online Coverage</span> The Free Press Journal",
      "title": "Think Long-Term, MSMEs First As Budget Backs Growth Through Six Key Pillars",
      "btnText": "Read More",
      "link": "https://www.freepressjournal.in/business/think-long-term-msmes-first-as-budget-backs-growth-through-six-key-pillars",
      "date": "02/02/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/Budget_2026.webp",
      "batch": "<span>Online Coverage</span> Budget Express",
      "title": "Budget 2026 focuses on building long-term growth capacity rather than short-term fiscal support",
      "btnText": "Read More",
      "link": "https://www.moneycontrol.com/news/business/personal-finance/budget-2026-focuses-on-building-long-term-growth-capacity-rather-than-short-term-fiscal-support-13806269.html",
      "date": "02/02/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Vikas_Satija_2.webp",
      "batch": "<span>Online Coverage</span> Mint Market",
      "title": "Fiscal deficit target for FY27 may be 4.2-4.3%; no big tweaks in HNI portfolios ahead of Budget: Shriram Wealth MD, CEO",
      "btnText": "Read More",
      "link": "https://www.livemint.com/market/stock-market-news/fiscal-deficit-target-for-fy27-may-be-4-2-4-3-no-big-tweaks-in-hni-portfolios-ahead-of-budget-shriram-wealth-md-ceo-11769748530601.html",
      "date": "30/01/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Gold___Silver_bar.webp",
      "batch": "<span>Online Coverage</span> News 18",
      "title": "Gold, Silver Hit Fresh Record Highs: Should Investors Expect More Upside?",
      "btnText": "Read More",
      "link": "https://www.news18.com/business/savings-and-investments/gold-silver-hit-fresh-record-highs-should-investors-expect-more-upside-ws-l-9824830.html",
      "date": "12/01/2026"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Vikas_Satija.webp",
      "batch": "<span>Online Coverage</span> Hubbis ",
      "title": "Building a Long-Term Wealth Platform: How Shriram Wealth Is Positioning for India’s Next Phase of Growth",
      "btnText": "Read More",
      "link": "https://www.hubbis.com/article/building-a-long-term-wealth-platform-how-shriram-wealth-is-positioning-for-india-s-next-phase-of-growth",
      "date": "02/01/2026"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/Nivesh_Ki_ABCD.webp",
      "batch": "<span>Iconic Brand</span> Stories",
      "title": "Nivesh Ki ABCD: GIFT सिटी क्या है? निवेशक के लिए क्यों महत्वपूर्ण है? | Vikas Satija | Jigar Patel",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/6fWckVmt7Uc?autoplay=1&mute=1",
      "date": "10/03/2026"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/GIFT_City_Explained.webp",
      "batch": "<span>The Money Show</span> ET Now",
      "title": "GIFT City Explained: Can It Transform Global Investing For Indians? | The Money Show | ET Now",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/Z6moLoBuVBE?autoplay=1&mute=1",
      "date": "10/03/2026"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/media/online/Video-2.webp",
      "batch": "<span>Iconic Brand</span> Stories",
      "title": "How Shriram Turned 50 Years of Trust into a Wealth Business | Vikas Satija | EP- 18 | Tina Garg",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/n8t8LaCI0kU?autoplay=1&mute=1",
      "date": "28/01/2026"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/Shriram_wealth.webp",
      "batch": "<span>Tech Observer</span> Podcast",
      "title": "Shriram Wealth CTO puneet Asthana on AI, Data and DPDP in BFSI | Digital India PodCast | Ep13",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/dzgbcgPp-6o?autoplay=1&mute=1",
      "date": "09/12/2025"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/Shriram_wealth_0325.webp",
      "batch": "<span>Podcast</span> NDTV Profit",
      "title": "Sanlam and Shriram Group Aim To Be In Top 15-20 Asset Managers In India | NDTV Profit",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/-2PAaA2Y1zg?autoplay=1&mute=1",
      "date": "19/11/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-28.webp",
      "batch": "<span>Online Coverage</span> The Economic Times",
      "title": "Human + Machine: The Strategic Advantage Shaping the Future of Investing",
      "btnText": "Read More",
      "link": "https://db.financialexpressb2b.com/blogs/human-machine-the-strategic-advantage-shaping-the-future-of-investing",
      "date": "11/12/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "assets/images/media/online/Shriram_wealth.webp",
      "batch": "<span> The Digital India </span> Podcast",
      "title": "The Digital India Podcast with Shriram Wealth ED & CTO Puneet Asthana | Episode 13",
      "btnText": "Read More",
      "link": "https://techobserver.in/podcast/the-digital-india-podcast-with-shriram-wealth-ed-cto-puneet-asthana-episode-13-319345/?amp",
      "date": "08/12/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Online-section-1.webp",
      "batch": "<span>Online Coverage</span> The Economic Times",
      "title": "ETMarkets Smart Talk| Focus on long-term themes; IPO frenzy offers lessons, not just opportunities,” says Shriram Wealth CEO",
      "btnText": "Read More",
      "link": "https://economictimes.indiatimes.com/markets/expert-view/etmarkets-smart-talk-focus-on-long-term-themes-ipo-frenzy-offers-lessons-not-just-opportunities-says-shriram-wealth-ceo/articleshow/125266240.cms",
      "date": "13/11/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Online-section-2.webp",
      "batch": "<span>Online Coverage</span> Financial Express",
      "title": "Ambition is to be among top 15 AMCs in India,’ Carl Roothman CEO Sanlam Investment Group",
      "link": "https://www.financialexpress.com/business/industry-ambition-is-to-be-among-top-15-amcs-in-india-carl-roothman-ceo-sanlam-investment-group-4042049/",
      "date": "13/11/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Online-section-3.webp",
      "batch": "<span>Online Coverage</span> The Hindu",
      "title": "Global funds trimming exposures amidst imminent correction in U.S. markets: Sanlam Group CEO ",
      "link": "https://www.thehindu.com/business/global-funds-trimming-exposures-amidst-imminent-correction-in-us-markets-sanlam-group-ceo/article70276727.ece",
      "date": "15/11/2025"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/Video-section-nov.webp",
      "batch": "<span>Podcast</span> Swadesh",
      "title": "Nivesh Ki ABCD: निवेशकों को ज्यादा रिटर्न पाने के लिए किन बातों का ध्यान रखना चाहिए? | Swadesh",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/NlYrGHIc1P8?autoplay=1&mute=1",
      "date": "15/11/2025"
    },
    {

      "mediaType": "Video",
      "image_url": "/assets/images/Video-section-nov2.webp",
      "batch": "<span>Podcast</span>  The Money Show ",
      "title": "India’s Wealth Boom | Shriram–Sanlam Partnership to Redefine Investing | The Money Show | Business",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/dQQEu98zigk?autoplay=1&mute=1",
      "date": "12/11/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/Airtcle_01.webp",
      "batch": "<span>The Free Press Journal</span>",
      "title": "A Will: Wealth's Final Safeguard",
      "alt_text": "A Will: Wealth's Final Safeguard",
      "btnText": "Read More",
      "link": "/assets/pdf/weath-final-safeguard.pdf",
      "date": "20/02/2026"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/Think_long.webp",
      "batch": "<span>The Free Press Journal</span>",
      "title": "Think long-term,MSMESfirst",
      "alt_text": "Think long-term,MSMESfirst",
      "btnText": "Read More",
      "link": "/assets/pdf/Think-long-term.pdf",
      "date": "02/02/2026"
    },

    {
      "mediaType": "Print",
      "image_url": "/assets/images/Print-Section-1.webp",
      "batch": "<span>Print</span> The Hindu",
      "title": "Global funds trimming exposures amidst Imminent correction in U.S. markets",
      "alt_text": "Global funds trimming exposures amidst Imminent correction in U.S. markets",
      "btnText": "Read More",
      "link": "/assets/pdf/global-funds-trimming.pdf",
      "date": "16/11/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/Shriram_wealth_01.webp",
      "batch": "<span>Online Coverage</span> Business World",
      "title": "Festive Cheer Meets Financial Clarity: Why Periodic Portfolio Reviews Power Long-term Wealth?",
      "btnText": "Read More",
      "link": "https://www.businessworld.in/article/festive-cheer-meets-financial-clarity-why-periodic-portfolio-reviews-power-long-term-wealth-577010",
      "date": "27/10/2025"
    },
    {

      "mediaType": "Online",
      "image_url": "/assets/images/Shriram_wealth_02.webp",
      "batch": "<span>News</span> Inside India",
      "title": "India’s emerging cities are the next wealth frontier: Shriram Wealth",
      "btnText": "Read More",
      "link": "https://www.cnbc.com/video/2025/10/24/indias-emerging-cities-are-the-next-wealth-frontier-shriram-wealth.html",
      "date": "24/10/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-32.webp",
      "batch": "<span>Online Coverage</span> Money Control",
      "title": "Daily Voice: Good monsoon, tamed inflation may give RBI MPC room to cut rates, says Shriram Wealth's Vikas Satija",
      "btnText": "Read More",
      "link": "https://www.moneycontrol.com/news/business/markets/daily-voice-good-monsoon-tamed-inflation-may-give-rbi-mpc-room-to-cut-rates-says-shriram-wealth-s-vikas-satija-13589141.html",
      "date": "05/10/2025"
    },
    {

      "mediaType": "Video",
      "image_url": "/assets/images/media/online/Video-1.webp",
      "batch": "<span>Podcast</span> EB Capital",
      "title": "Where to Invest in India (2025 & Beyond) | Podcast with Vikas Satija",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/QwlPyrFXyh0?autoplay=1&mute=1",
      "date": "05/10/2025"
    },
    {

      "mediaType": "Video",
      "image_url": "/assets/images/media/online/Video-2.webp",
      "batch": "<span>Podcast</span> Simple Hai!",
      "title": "How To Build Wealth That Lasts? | Vikas Satija, MD & CEO of Shriram Wealth Breaks It All Down",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/2ihM6wuqEWI?autoplay=1&mute=1",
      "date": "05/10/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/Print-1.webp",
      "batch": "<span>Print</span> The Free Press Journal",
      "title": "'Build Wealth That Lasts' The Road To Fortune",
      "alt_text": "'Build Wealth That Lasts' The Road To Fortune",
      "btnText": "Read More",
      "link": "/assets/pdf/print-media.pdf",
      "date": "05/10/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-31.webp",
      "batch": "<span>Online Coverage</span> Money Control",
      "title": "Shriram Wealth bets on 'democratising' wealth, to soon enter Rs 10 lakhs-Rs 2 crore segment",
      "btnText": "Read More",
      "link": "https://www.moneycontrol.com/news/business/companies/shriram-wealth-bets-on-democratising-wealth-to-soon-enter-rs-10-lakhs-rs-2-crore-segment-13549850.html",
      "date": "15/09/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-30.webp",
      "batch": "<span>Online Coverage</span> Economic Times",
      "title": "GST 2.0 and ripple effect on luxury, investments, and wealth planning",
      "btnText": "Read More",
      "link": "https://economictimes.indiatimes.com/markets/stocks/news/gst-2-0-and-ripple-effect-on-luxury-investments-and-wealth-planning/articleshow/123878639.cms?from=mdr",
      "date": "15/09/2025"
    },
    {

      "mediaType": "Video",
      "image_url": "/assets/images/media/online/BFSI.webp",
      "batch": "<span>ONLINE COVERAGE</span> ET BFSI",
      "title": "India’s organised wealth to grow 8x by 2047, massive scope for new players: Shriram Wealth CEO",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/ck_KIxmxyGk?autoplay=1&mute=1",
      "date": "15/09/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-29.webp",
      "batch": "<span>Online Coverage</span> BW",
      "title": "India’s Wealth Landscape Is Shifting — Are Your Financial Habits Evolving Too?",
      "btnText": "Read More",
      "link": "https://www.businessworld.in/article/indias-wealth-landscape-is-shifting-are-your-financial-habits-evolving-too-570512",
      "date": "08/09/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-28.webp",
      "batch": "<span>Online Coverage</span> ETCIO",
      "title": "Beyond the dashboard: Personalization through data in wealth management",
      "btnText": "Read More",
      "link": "https://cio.economictimes.indiatimes.com/news/artificial-intelligence/unlocking-wealth-management-the-power-of-hyper-personalization-and-ai/123625414?utm_source=portal_category_widget&utm_medium=homepage",
      "date": "01/09/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "assets/images/media/online/online-img-2.webp",
      "batch": "<span>Online Coverage</span> TechCircle",
      "title": "Shriram Wealth’s CTO on tech strategy, balancing innovation, and compliance cost",
      "btnText": "Read More",
      "link": "https://www.techcircle.in/2025/08/18/shriram-wealth-s-cto-on-tech-strategy-balancing-innovation-and-compliance-cost",
      "date": "18/08/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-26.webp",
      "batch": "<span>Online Coverage</span> The New Indian Express",
      "title": "Only 15% of wealth in India is formally managed: Vikas Satija of Shriram Wealth",
      "btnText": "Read More",
      "link": "https://www.newindianexpress.com/business/2025/Aug/11/only-15-of-wealth-in-india-is-formally-managed-vikas-satija-of-shriram-wealth",
      "date": "12/08/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-51.webp",
      "batch": "<span>Print</span> Andhra Jyoti",
      "title": "Shriram Wealth signs agreement with Roundtable India",
      "alt_text": "Shriram Wealth signs agreement with Roundtable India",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-51.pdf",
      "date": "09/08/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-52.webp",
      "batch": "<span>Print</span> Mathrubhumi",
      "title": "Shriram Wealth to collaborate with Roundtable",
      "alt_text": "Shriram Wealth to collaborate with Roundtable",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-52.pdf",
      "date": "08/08/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-27.webp",
      "batch": "<span>Online Coverage</span> The Finance Outlook India",
      "title": "Shriram Wealth Partners with Round Table India for Financial Literacy, Philanthropic Initiatives",
      "btnText": "Read More",
      "link": "https://www.financeoutlookindia.com/news/shriram-wealth-partners-with-round-table-india-for-financial-literacy-philanthropic-initiatives-nwid-5846.html",
      "date": "07/08/2025"
    },

    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-12.webp",
      "batch": "<span>Online Coverage</span> THE ECONOMIC TIMES",
      "title": "ETMarkets Smart Talk | Festive demand, monsoon could lift markets in 2H-2025: Shriram Wealth CEO",
      "btnText": "Read More",
      "link": "https://economictimes.indiatimes.com/markets/expert-view/etmarkets-smart-talk-festive-demand-monsoon-could-lift-markets-in-h2fy25-shriram-wealth-ceo/articleshow/122831015.cms?from=mdr",
      "date": "28/07/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-47.webp",
      "batch": "<span>Print</span> The Times of India",
      "title": "Legacy companies pan focus on financial services for affluent, HNIs and UHNIs",
      "alt_text": "Legacy companies pan focus on financial services for affluent, HNIs and UHNIs",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-47.pdf",
      "date": "10/07/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-26.webp",
      "batch": "<span>Online Coverage</span> FE BFSI",
      "title": "5 Trends that will Shape Wealth Management Industry in India Ahead",
      "btnText": "Read More",
      "link": "https://bfsi.financialexpress.com/blogs/5-trends-that-will-shape-wealth-management-industry-in-india-ahead",
      "date": "02/07/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-46.webp",
      "batch": "<span>Print</span> The Hindu",
      "title": "Investors like to buy many financial products under one umbrella: Satija",
      "alt_text": "Investors like to buy many financial products under one umbrella: Satija",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-46.pdf",
      "date": "22/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-45.webp",
      "batch": "<span>Print</span> Divya Bhaskar (Gujarati)",
      "title": "Joint venture to popularize wealth management",
      "alt_text": "Joint venture to popularize wealth management",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-45.pdf",
      "date": "22/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-44.webp",
      "batch": "<span>Print</span> The Sunday Standard",
      "title": "Shriram Group, Sanlam JV to float wealth venture",
      "alt_text": "Shriram Group, Sanlam JV to float wealth venture",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-44.pdf",
      "date": "22/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-43.webp",
      "batch": "<span>Print</span> The Hindu Business Line",
      "title": "Shriram Wealth sees potential in emerging affluent segment",
      "alt_text": "Shriram Wealth sees potential in emerging affluent segment",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-43.pdf",
      "date": "21/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-42.webp",
      "batch": "<span>Print</span> Dina Malar (Tamil)",
      "title": "Shriram Group Launches Shriram Wealth",
      "alt_text": "Shriram Group Launches Shriram Wealth",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-42.pdf",
      "date": "21/06/2025"
    },
    // New online
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-1.webp",
      "batch": "<span>Online Coverage</span> Cafe Mutual",
      "title": "Shriram ties up with South Africa's Sanlam to launch wealth management business",
      "btnText": "Read More",
      "link": "https://cafemutual.com/news/cafe-alt/35110-shriram-ties-up-with-south-africas-sanlam-to-launch-wealth-management-business",
      "date": "19/06/2025"
    },

    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-41.webp",
      "batch": "<span>Print</span> Loksatta (Marathi)",
      "title": "Shriram Wealth targets assets worth Rs 50,000 crore in five years",
      "alt_text": "Shriram Wealth targets assets worth Rs 50,000 crore in five years",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-41.pdf",
      "date": "18/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-40.webp",
      "batch": "<span>Print</span> Sakal (Marathi)",
      "title": "Shriram Wealth company launched",
      "alt_text": "Shriram Wealth company launched",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-40.pdf",
      "date": "17/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-39.webp",
      "batch": "<span>Print</span> Deccan Herald",
      "title": "Bluru HNIs, UHNIs lead In alternate investment",
      "alt_text": "Bluru HNIs, UHNIs lead In alternate investment",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-39.pdf",
      "date": "17/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-50.webp",
      "batch": "<span>Print</span> Mathrubhumi (Malayalam)",
      "title": "Shriram Group launches wealth management company",
      "alt_text": "Shriram Group launches wealth management company",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-50.pdf",
      "date": "15/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-2.webp",
      "batch": "<span>Online Coverage</span> loksatta.com",
      "title": "‘श्रीराम वेल्थ’चे पाच वर्षात ५०,००० कोटी मालमत्तेचे लक्ष्य, ‘सनलॅम’शी भागीदारीतून संयुक्त उपक्रम",
      "btnText": "Read More",
      "link": "https://www.loksatta.com/business/finance/shriram-wealth-targets-rs-50000-crore-in-assets-in-five-years-joint-venture-in-partnership-with-sanlam-print-eco-news-asj-82-5156022/",
      "date": "14/06/2025"

    },

    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-38.webp",
      "batch": "<span>Print</span> Vyapar (Gujarati)",
      "title": "Shriram Group's wealth management company joins hands with Sanlam Group",
      "alt_text": "Shriram Group's wealth management company joins hands with Sanlam Group",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-38.pdf",
      "date": "14/06/2025"
    },

    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-5.webp",
      "batch": "<span>Print</span> The Hindu",
      "title": "Shriram Group, Sanlam foray into wealth management JV",
      "alt_text": "Shriram Group, Sanlam foray into wealth management JV",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-5.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-6.webp",
      "batch": "<span>Print</span> The Economic Times",
      "title": "Shriram Grp, Sanlam Ink Wealth Mgmt JV",
      "alt_text": "Shriram Grp, Sanlam Ink Wealth Mgmt JV",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-6.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-7.webp",
      "batch": "<span>Print</span> Business Standard",
      "title": "Shriram group enters wealth management space via Sanlam JV",
      "alt_text": "Shriram group enters wealth management space via Sanlam JV",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-7.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-9.webp",
      "batch": "<span>Print</span> Mint",
      "title": "Sanlam sharpens India focus with JV",
      "alt_text": "Sanlam sharpens India focus with JV",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-9.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-10.webp",
      "batch": "<span>Print</span> The Hindu Business Line",
      "title": "Shriram Group enters wealth management, forms 50:50 joint venture with Sanlam",
      "alt_text": "Shriram Group enters wealth management, forms 50:50 joint venture with Sanlam",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-10.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-11.webp",
      "batch": "<span>Print</span> Deccan Chronicle",
      "title": "Shriram Group co announces new joint venture",
      "alt_text": "Shriram Group co announces new joint venture",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-11.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-13.webp",
      "batch": "<span>Print</span> Sakshi (Telugu)",
      "title": "Shri Ram group wealth services",
      "alt_text": "Shri Ram group wealth services",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-13.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Print",
      "image_url": "/assets/images/media/blog-8.webp",
      "batch": "<span>Print</span> Financial Express",
      "title": "Shriram plans foray into alternate investment space",
      "alt_text": "Shriram plans foray into alternate investment space",
      "btnText": "Read More",
      "link": "/assets/images/pdf/blog-8.pdf",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-3.webp",
      "batch": "<span>Online Coverage</span> The Financial Express",
      "title": "Shriram plans foray into alternate investment space",
      "btnText": "Read More",
      "link": "https://www.financialexpress.com/business/industry-shriram-plans-foray-into-alternate-investment-space-3878052/",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-4.webp",
      "batch": "<span>Online Coverage</span> Gujarati News",
      "title": "શ્રીરામ ગ્રુપની વેલ્થ મૅનેજમેન્ટ કંપનીએ સેનલેમ ગ્રુપ સાથે હાથ મિલાવ્યા",
      "btnText": "Read More",
      "link": "https://www.janmabhoominewspapers.com/news/vyapar/23776",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-6.webp",
      "batch": "<span>Online Coverage</span> Marca Money",
      "title": "Shriram Group partners with South Africas Sanlam Group to launch Shriram Wealth",
      "btnText": "Read More",
      "link": "https://www.marcamoney.com/shriram-group-partners-with-south-africas-sanlam-group-to-launch-shriram-wealth/",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-7.webp",
      "batch": "<span>Online Coverage</span> CityWire",
      "title": "Round up: Launches and hires in India's booming wealth market",
      "btnText": "Read More",
      "link": "https://citywire.com/asia/news/round-up-launches-and-hires-in-indias-booming-wealth-market/a2467847",
      "date": "13/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-8.webp",
      "batch": "<span>Online Coverage</span> The Hindu",
      "title": "Shriram Group forays into wealth management through joint venture with Sanlam",
      "btnText": "Read More",
      "link": "https://www.thehindu.com/incoming/shriram-group-forays-into-wealth-management-through-joint-venture-with-sanlam/article69687510.ece",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-9.webp",
      "batch": "<span>Online Coverage</span> Prahaar",
      "title": "'प्रहार' Exclusive:श्रीराम समुहाने सनलाम समुहासोबत केली धोरणात्मक भागीदारी 'श्रीराम वेल्थ' ब्रँड भारतात लॉन्च",
      "btnText": "Read More",
      "link": "https://prahaar.in/2025/06/12/prahaar-exclusive-shriram-group-enters-into-strategic-partnership-with-sanlam-group-to-launch-shriram-wealth-brand-in-india/",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-12.webp",
      "batch": "<span>Online Coverage</span> europesays",
      "title": "South Africa’s Sanlam sharpens India focus with Shriram wealth management JV",
      "btnText": "Read More",
      "link": "https://www.europesays.com/2157341/",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-13.webp",
      "batch": "<span>Online Coverage</span> hotscup",
      "title": "Shriram Group ka Dhamaka: Naya Wealth Venture! ????",
      "btnText": "Read More",
      "link": "https://hotscup.com/shriram-group-ka-dhamaka-naya-wealth-venture-%f0%9f%92%b0/",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-14.webp",
      "batch": "<span>Online Coverage</span> ET Realty",
      "title": "Game-Changer: Shriram Properties Launches South Punes First Downtown in Undri",
      "btnText": "Read More",
      "link": "https://realty.economictimes.indiatimes.com/news/brand-connect-initiative/shriram-properties-unveils-punes-first-downtown-in-undri-transforming-real-estate/121803905",
      "date": "12/06/2025"
    },

    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-16.webp",
      "batch": "<span>Online Coverage</span> The Hindu Business Line",
      "title": "Shriram Wealth debuts, targets ₹50,000 cr Asset Under Advice over 5 years",
      "btnText": "Read More",
      "link": "https://www.thehindubusinessline.com/money-and-banking/shriram-wealth-debuts-targets-50000-cr-asset-under-advice-over-5-years/article69686400.ece",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-17.webp",
      "batch": "<span>Online Coverage</span> Moneycontrol",
      "title": "Shriram Group launches wealth management arm in partnership with Sanlam Group",
      "btnText": "Read More",
      "link": "https://www.moneycontrol.com/news/business/markets/shriram-group-launches-wealth-management-arm-in-partnership-with-sanlam-group-13113197.html",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-18.webp",
      "batch": "<span>Online Coverage</span> Business Today",
      "title": "Shriram Group & South Africas Sanlam Group join hands to launch Shriram Wealth with 50:50 JV",
      "btnText": "Read More",
      "link": "https://www.businesstoday.in/personal-finance/investment/story/shriram-group-south-africas-sanlam-group-join-hands-to-launch-shriram-wealth-with-5050-jv-480228-2025-06-12",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-15.webp",
      "batch": "<span>Online Coverage</span> Mint",
      "title": "South Africas Sanlam sharpens India focus with Shriram wealth management JV",
      "btnText": "Read More",
      "link": "https://www.livemint.com/industry/south-africa-sanlam-shriram-wealth-nagpur-coimbatore-economy-growth-11749726133058.html",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-21.webp",
      "batch": "<span>Online Coverage</span> Startup News",
      "title": "Shriram Group Launches Shriram Wealth, a Strategic 50:50 Joint Venture with Sanlam Group",
      "btnText": "Read More",
      "link": "https://startupnews.fyi/2025/06/12/shriram-group-launches-shriram-wealth-a-strategic-5050-joint-venture-with-sanlam-group/",
      "date": "12/06/2025"
    },
    {
      "mediaType": "Online",
      "image_url": "/assets/images/media/online/online-img-23.webp",
      "batch": "<span>Online Coverage</span> MSN India",
      "title": "Not giving Sanlam more than 50% stake in Shriram Wealth, says Shriram Capital CEO",
      "btnText": "Read More",
      "link": "https://www.msn.com/en-in/money/markets/not-giving-sanlam-more-than-50-stake-in-shriram-wealth-says-shriram-capital-ceo/ar-AA1GzFRV",
      "date": "12/06/2025"
    },
    // Video

    {

      "mediaType": "Video",
      "image_url": "/assets/images/media/thumbnail1.webp",
      "batch": "<span>Online Coverage</span> CNBC TV18",
      "title": "Shriram Group & Sanlam to invest Rs.200 Crore in Shriram Wealth.",
      "subText": "Chennai-based Shriram Group and South Africa’s Sanlam have announced plans to invest ₹200 crore in their newly formed 50:50 joint venture—Shriram Wealth...",
      "alt_text": "CNBC TV18",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/SCcyAVpbuw4?autoplay=1&si=s_XK8SmjsB3OQwFo",
      "date": "15/09/2025"
    },
    {
      "mediaType": "Video",
      "image_url": "/assets/images/media/online/online-img-12.webp",
      "batch": "<span>Podcast</span> Ultra",
      "title": "Shriram Group 50 year old legacy secret! How to build a legacy brand?",
      "alt_text": "Ultra",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/c5r-6osd-VM?si=HfeY5PJItBOtEJfg&autoplay=1&mute=1"
    },

    {
      "mediaType": "Press release",
      "image_url": "/assets/images/media/online/online-img-23.webp",
      "batch": "<span>Press release</span>",
      "title": "Shriram Group Launches Shriram Wealth, a Strategic 50:50 Joint Venture with Sanlam Group",
      "alt_text": "Shriram Group Launches Shriram Wealth, a Strategic 50:50 Joint Venture with Sanlam Group",
      "btnText": "Read More",
      "link": "/assets/images/pdf/press-release.pdf",
      "date": "22/06/2025"
    },

    {

      "mediaType": "Video",
      "image_url": "/assets/images/media/gift-city-gui.webp",
      "batch": "<span>The Economic Times Hindi</span>",
      "title": "गिफ्ट सिटी और ग्लोबल इन्वेस्टमेंट: आम आदमी विदेश में पैसा कैसे लगाए? | विकास सतीजा | श्रीराम वेल्थ",
      "subText": "Chennai-based Shriram Group and South Africa’s Sanlam have announced plans to invest ₹200 crore in their newly formed 50:50 joint venture—Shriram Wealth...",
      "alt_text": "CNBC TV18",
      "btnText": "Read More",
      "link": "https://www.youtube.com/embed/YFGdpC1z_Vo",
      "date": "03/07/2026"
    },

  ];
  activeTabIndex: number = 0;
  expandedMonths: Set<string> = new Set();

  ngOnInit() {
    const firstMonth = this.getUniqueMonths()[0];
    if (firstMonth) {
      this.expandedMonths.add(firstMonth);
    }

    if (typeof document !== 'undefined') {
      setTimeout(() => {
        let tabButtons = document.querySelectorAll('.tab-button');
        tabButtons.forEach(button => {
          button.addEventListener('click', () => {
            button.scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          });
        });
      }, 100);
    }
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
    this.expandedMonths.clear();
    const firstMonth = this.getUniqueMonths()[0];
    if (firstMonth) {
      this.expandedMonths.add(firstMonth);
    }
  }

  get activeTab(): string {
    return this.tabs[this.activeTabIndex].id;
  }

  toggleMonth(monthName: string) {
    if (this.expandedMonths.has(monthName)) {
      this.expandedMonths.delete(monthName);
    } else {
      this.expandedMonths.clear();
      this.expandedMonths.add(monthName);
    }
  }

  isMonthExpanded(monthName: string): boolean {
    return this.expandedMonths.has(monthName);
  }

  getUniqueMonths() {
    const months = this.categoryData
      .filter(item => item.mediaType === this.activeTab && item.date)
      .map(item => {
        const [day, month, year] = item.date!.split('/');
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return `${monthNames[parseInt(month) - 1]} - ${year}`;
      });
    return [...new Set(months)].sort((a, b) => {
      const [monthA, yearA] = a.split(' - ');
      const [monthB, yearB] = b.split(' - ');
      const dateA = new Date(parseInt(yearA), new Date(Date.parse(monthA + ' 1, 2000')).getMonth());
      const dateB = new Date(parseInt(yearB), new Date(Date.parse(monthB + ' 1, 2000')).getMonth());
      return dateB.getTime() - dateA.getTime();
    });
  }

  getArticlesByMonth(monthName: string) {
    return this.categoryData.filter(item => {
      if (item.mediaType !== this.activeTab || !item.date) return false;
      const [day, month, year] = item.date!.split('/');
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const itemMonth = `${monthNames[parseInt(month) - 1]} - ${year}`;
      return itemMonth === monthName;
    });
  }
}